var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { VuexModule, Module, MutationAction, Mutation } from 'vuex-module-decorators';
import appstore from '../index';
import axios from 'axios';
import { print } from 'graphql';
import gql from 'graphql-tag';
let Service = class Service extends VuexModule {
    constructor() {
        super(...arguments);
        this.projects = {};
        this.articlesData = {};
        this.videosData = {};
        this.documentsData = {};
        this.engagementsData = {};
        this.jobsData = {};
        this.sectors = {};
        this.locations = {};
        this.participations = {};
        this.itemCount = 0;
    }
    setProjects(projects) {
        this.projects = projects;
    }
    getProjectBrowserData(args) {
        return __awaiter(this, void 0, void 0, function* () {
            let projects = [];
            let sectors = [];
            let locations = [];
            let participations = [];
            const showOnHomepage = args.showOnHomepage ? args.showOnHomepage : null;
            const showOnPartnershipMap = args.showOnPartnershipMap ? args.showOnPartnershipMap : null;
            const siteId = args.siteId ? args.siteId : 1;
            const transform = args.transform ? args.transform : 'homeProjectBrowser';
            yield axios({
                url: '/admin/actions/graphql/api',
                method: 'post',
                data: {
                    query: print(gql `
          {
            entries(section: "projects", orderBy: "homepageOrder asc", showOnHomepage: ${showOnHomepage}, showOnPartnershipMap: ${showOnPartnershipMap}, siteId: ${siteId}){
              id
              title
              url
              ... on project_Entry {
                tagLine
                showOnHomepage
                showOnPartnershipMap
                mapXPosition
                mapYPosition
                sector {
                  ... on sector_Category {
                    id
                    title
                    subtitle
                  }
                }
                locationCategories {
                  ... on partnershipLocation_Category {
                    id
                    title
                  }
                }
                participationCategories {
                  ... on partnershipParticipation_Category {
                    id
                    title
                  }
                }
                commitment
                launch
                location
                partner
                image {
                  default: url @transform(handle: "${transform}")
                  large: url @transform(handle: "article960x460")
                  ... on images_Asset {
                    altText
                  }
                }
              }
            }
            sectors: categories(group: "sector", siteId: ${siteId}) {
              id
              title
              url
              ... on sector_Category {
                subtitle
              }
            }
            locations: categories(group: "partnershipLocation", siteId: ${siteId}) {
              id
              title
            }
            participations: categories(group: "partnershipParticipation", siteId: ${siteId}) {
              id
              title
            }
          }
        `)
                }
            }).then((result) => {
                projects = result.data.data.entries;
                sectors = result.data.data.sectors;
                locations = result.data.data.locations;
                participations = result.data.data.participations;
            }).catch((error) => {
            });
            return { projects, sectors, locations, participations };
        });
    }
    getProjects(args) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('getProjects', args);
            let projects = [];
            let relatedToCategories = args.relatedToCategories ? (_a = args.relatedToCategories) === null || _a === void 0 ? void 0 : _a.join(',') : '';
            let siteId = args.siteId || 1;
            let exclude = ((_b = args.excludes) === null || _b === void 0 ? void 0 : _b.join(',')) || '';
            yield axios({
                url: '/admin/actions/graphql/api',
                method: 'post',
                data: {
                    query: print(gql `
				{
          entries(section: "projects", id: ["not", ${exclude}], relatedToCategories: {id:[${relatedToCategories}]}, siteId: ${siteId}){
            id
            title
            url
            ... on project_Entry {
              pageTitle
              introText
              image {
                default: url @transform(handle: "relatedProjects")
              }
              sector {
                ... on sector_Category {
                  id
                  title
                  url
                }
              }
              commitment
              location
              partner
            }
          }
        }`)
                }
            }).then((result) => {
                projects = result.data.data.entries;
                projects.forEach((project) => {
                    project.commitment = project.commitment.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2');
                });
            }).catch((error) => {
            });
            return { projects };
        });
    }
    getArticles(args) {
        return __awaiter(this, void 0, void 0, function* () {
            this.state.articlesData = [];
            let articlesData = [];
            let sectors = [];
            let itemCount = 0;
            let relatedToCategories = args.relatedToCategories ? args.relatedToCategories : null;
            let siteId = args.siteId || 1;
            let limit = args.limit || 5;
            let offset = args.offset || 0;
            let year = args.year || 0;
            let yearQuery = year === 0 ? null : `["and", ">=${year}-01-01", "<=${year}-12-31"]`;
            yield axios({
                url: '/admin/actions/graphql/api',
                method: 'post',
                data: {
                    query: print(gql `
				{
					articles: entries(section: "articles", siteId: ${siteId}, limit: ${limit}, offset: ${offset}, relatedToCategories: {id:${relatedToCategories}}, postDate: ${yearQuery}, hideArticleFromList: false) {
					  id
					  title
					  url
					  postDate @formatDateTime(format: "${window.cibbic.dateFormat}", locale: "${window.cibbic.language}")
					  ... on article_Entry {
							sector {
                ... on sector_Category {
                  id
                  title
                  url
                }
              }
              pageTitle
              image {
                large: url @transform(handle: "article960x460")
                medium: url @transform(handle: "article430x270")
                small: url @transform(handle: "article430x400")
                ... on images_Asset {
                  altText
                }
              }
              teaserImage {
                large: url @transform(handle: "article960x460")
                medium: url @transform(handle: "article430x270")
                small: url @transform(handle: "article430x400")
                ... on images_Asset {
                  altText
                }
              }
					  }
					},
					sectors: categories(group: "sector", siteId: ${siteId}) {
					  id
					  title
					  url
            ... on sector_Category {
              subtitle
            }
					},
					first: entries(section: "articles", siteId: ${siteId}, limit: 1, relatedToCategories: {id:${relatedToCategories}}, orderBy: "postDate DESC"){
						postDate @formatDateTime(format: "Y")
					},
					last: entries(section: "articles", siteId: ${siteId}, limit: 1, relatedToCategories: {id:${relatedToCategories}}, orderBy: "postDate ASC"){
						postDate @formatDateTime(format: "Y")
					}
					entryCount(section: "articles", siteId: 1, relatedToCategories: {id: ${relatedToCategories}}, postDate: ${yearQuery})
				}
			`)
                }
            }).then((result) => {
                articlesData = result.data.data;
                sectors = result.data.data.sectors;
                itemCount = result.data.data.entryCount;
            }).catch((error) => {
            });
            return { articlesData, sectors, itemCount };
        });
    }
    getVideos(args) {
        return __awaiter(this, void 0, void 0, function* () {
            this.state.videosData = [];
            let videosData = [];
            let sectors = [];
            let itemCount = 0;
            let relatedToCategories = args.relatedToCategories ? args.relatedToCategories : null;
            let siteId = args.siteId || 1;
            let limit = args.limit || 12;
            let offset = args.offset || 0;
            yield axios({
                url: '/admin/actions/graphql/api',
                method: 'post',
                data: {
                    query: print(gql `
				{
					videos: entries(section: "videos", siteId: ${siteId}, limit: ${limit}, offset: ${offset}, relatedToCategories: {id:${relatedToCategories}}) {
					  id
					  title
					  url
					  postDate @formatDateTime(format: "${window.cibbic.dateFormat}", locale: "${window.cibbic.language}")
					  ... on videos_default_Entry {
							sector {
                ... on sector_Category {
                  id
                  title
                  url: slug
                }
              }
              ctaButtonLink {
                ... on project_Entry {
                  id
                  url
                }
                ...on article_Entry {
                  id
                  url
                }
              }
              youtubeId,
              videoDescription
					  }
					},
					sectors: categories(group: "sector", siteId: ${siteId}) {
					  id
					  title
					  url: slug
            ... on sector_Category {
              subtitle
            }
					},
					first: entries(section: "videos", siteId: ${siteId}, limit: 1, relatedToCategories: {id:${relatedToCategories}}, orderBy: "postDate DESC"){
						postDate @formatDateTime(format: "Y")
					},
					last: entries(section: "videos", siteId: ${siteId}, limit: 1, relatedToCategories: {id:${relatedToCategories}}, orderBy: "postDate ASC"){
						postDate @formatDateTime(format: "Y")
					}
					entryCount(section: "videos", siteId: 1, relatedToCategories: {id: ${relatedToCategories}})
				}
			`)
                }
            }).then((result) => {
                console.log(result);
                videosData = result.data.data;
                sectors = result.data.data.sectors;
                itemCount = result.data.data.entryCount;
            }).catch((error) => {
            });
            return { videosData, sectors, itemCount };
        });
    }
    getDocuments(args) {
        return __awaiter(this, void 0, void 0, function* () {
            let documentsData = {};
            let siteId = args.siteId || 1;
            yield axios({
                url: '/admin/actions/graphql/api',
                method: 'post',
                data: {
                    query: print(gql `
          {
            entries(section: "documents", type:["default"], siteId: ${siteId}){
                id
                title
                postDate
                ... on documents_default_Entry {
                  docType {
                    ... on docType_Category {
                      id
                      title
                    }
                  },
                  docYear,
                  document {
                    ... on files_Asset {
                      url
                    }
                  }
                }
            }
            reportCount: entryCount(section: "documents", type:["default"], siteId: 1)
          }
        `)
                }
            }).then((result) => {
                documentsData = result.data.data.entries;
            }).catch((error) => {
            });
            return { documentsData };
        });
    }
    getPublicEngagements(args) {
        return __awaiter(this, void 0, void 0, function* () {
            let engagementsData = {};
            let siteId = args.siteId || 1;
            yield axios({
                url: '/admin/actions/graphql/api',
                method: 'post',
                data: {
                    query: print(gql `
				{
					entries(section: "publicEngagement", siteId: ${siteId}){
					  id
					  title
					  postDate @formatDateTime(format: "${window.cibbic.dateFormat}", locale: "${window.cibbic.language}")
					  ... on default_Entry {
              body
              image {
                url @transform(handle: "engagementLogo")
              }
              imageFigcaption
              subtitle
              externalLink
					  }
					},
					count: entryCount(section: "publicEngagement", siteId:${siteId})
				}
			`)
                }
            }).then((result) => {
                engagementsData = result.data.data;
            }).catch((error) => {
            });
            return { engagementsData };
        });
    }
    getJobs(args) {
        return __awaiter(this, void 0, void 0, function* () {
            let jobsData = {};
            let siteId = args.siteId || 1;
            yield axios({
                url: '/admin/actions/graphql/api',
                method: 'post',
                data: {
                    query: print(gql `
				{
					entries(section: "jobs", siteId: ${siteId}, expired: false){
						id
						title
						postDate
						url
						... on job_Entry{
						  pageTitle,
						  jobType {
							... on jobType_Category {
							  id
							  title
							}
						  }
						  jobLocation {
							... on jobLocation_Category {
							  id
							  title
							}
						  }
						  jobFunction {
							... on jobFunction_Category {
							  id
							  title
							}
						  }
						}
					  },
					count: entryCount(section: "jobs", siteId:${siteId}, expired: false)
				}
			`)
                }
            }).then((result) => {
                jobsData = result.data.data;
            }).catch((error) => {
            });
            return { jobsData };
        });
    }
};
__decorate([
    Mutation
], Service.prototype, "setProjects", null);
__decorate([
    MutationAction
], Service.prototype, "getProjectBrowserData", null);
__decorate([
    MutationAction
], Service.prototype, "getProjects", null);
__decorate([
    MutationAction
], Service.prototype, "getArticles", null);
__decorate([
    MutationAction
], Service.prototype, "getVideos", null);
__decorate([
    MutationAction
], Service.prototype, "getDocuments", null);
__decorate([
    MutationAction
], Service.prototype, "getPublicEngagements", null);
__decorate([
    MutationAction
], Service.prototype, "getJobs", null);
Service = __decorate([
    Module({ namespaced: true, store: appstore })
], Service);
export default Service;
